module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Introduction"
    }
  }, [_c('p', {
    staticClass: "intimg"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "alt": "",
      "src": "images/common.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "int_h",
    attrs: {
      "id": "sec2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253064967_Contents#rsec2"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN THIS BEGINNING AND TO THIS PARTICULAR END")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Uprooted from his Polish home, Ignacy Schwarzbart sat down at a borrowed desk in London to write yet another report in November 1940. As a one-time newspaper editor and prewar Sejm representative, as well as a current member of the Polish government-in-exile, Schwarzbart expressed his opinions with a mix of journalistic precision and political authority. Upon completion, the report traveled by post and secretarial hands to the offices of the World Jewish Congress (WJC) in Geneva, London, and New York City. Besides his high-profile job in Prime Minister Władysław Sikorski’s exiled government, Schwarzbart served as a representative to the WJC (a transnational organization established in 1936 to represent “all” Jews living throughout the diaspora), and he sometimes submitted reports to their headquarters."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Written thirteen months into the massive European conflict that became known as the Second World War, this report contains some of the earliest wartime ideas that Schwarzbart sent to his WJC colleagues. At a time when Nazi occupation authorities were just sealing the Warsaw Ghetto, Schwarzbart could imagine only one eventuality for the Polish Jewish collective to which he himself belonged. Even if Zionist-inspired plans for Jewish settlement in Palestine developed in the “most” favorable direction, signficant numbers of Jews, Schwarzbart acknowledged, would continue to live in “postwar” Poland and in Europe more generally."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No one could predict the shape of plans for Jewish migration out of east central Europe, whether British authorities would increase emigration into Mandate Palestine, or how the war might uproot Jews and others, but such "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("uncertainties did not concern Schwarzbart. In fact, he called attention to only “one danger” at this historic moment, a danger that surprisingly originated from within the Jewish people themselves: “the theory of liquidating the "), _c('i', [_vm._v("golus")]), _vm._v(".”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" By using a Yiddish word for the “diaspora,” Schwarzbart was referring to a broader idea that had percolated among Jewish nationalists for generations and had roots stemming from much older Jewish traditions. Essentially, modern and ancient supporters of this theory called for the coming together, or “ingathering,” of (presumably) “dispersed” Jews to the lands within and around Jerusalem as well as that city’s Temple complex.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Such a mass movement toward the eastern part of the Mediterranean would dramatically impact the peoples living in the space between Salzburg and St. Petersburg, where a majority of the world’s Jews lived by the time of Schwarzbart’s birth in the Austrian Galician town of Chrzanów in 1888. At the age of fifty-two and living through his second global war, Schwarzbart used his report in November 1940 to “oppose” those who wanted to “negate” the Polish Jewish diaspora. Instead, he wanted to guarantee “the development of Jewish culture” amid “the nations among whom [the Jews] live.” For this exiled Polish Jew and many of his generation, the Jewish diaspora would clearly remain rooted in east central Europe after the current war and occupation. Thoughts supporting the alternative were, in his opinion, “dangerous.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A mere seven years later, the danger had shifted starkly: the drastically diminished Jewish diaspora remaining in east central Europe had "), _c('i', [_vm._v("itself")]), _vm._v(" become dangerous. Support for that diaspora’s continued existence imperiled the building up of a Jewish state on the territory of Mandate Palestine. By June 1947, much had changed. First, the great majority of a diverse and numerous "), _c('i', [_vm._v("goles")]), _vm._v(" had been violently uprooted, dehumanized, and killed during the Shoah. Second, widely accepted ideas about minority rights had been replaced with Allied-endorsed plans for population transfers meant to cause political and ethnic boundaries in east central Europe to coincide. Third, Jewish and non-Jewish supporters of the “diaspora” now imagined that the displaced Jews of east central Europe would belong to a Jewish polity in the Middle East and could be transferred there with the support of the United Nations as part of the unmixing of ethnic populations in places such as Poland and Czechoslovakia. This collection of revolutionary ideas had, in the two years since Victory-in-Europe Day, accrued acceptance throughout the Allied universe of diplomats, statesmen, nongovernmental officials, and caretakers within the United Nations Relief and Rehabilitation Administration (UNRRA).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ignacy Schwarzbart shared in this acceptance. By June 1947, permanently uprooted from his Polish home, he worked full-time in New York City as the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("head of the Organization Department for the World Jewish Congress. The exiled Polish government still existed, but few states recognized it. Schwarzbart’s erstwhile “dogma” about the future rootedness of the Jewish diaspora in east central Europe had become unrecognizable. In fact, now the WJC wanted the surviving Jewish diaspora remaining on the European continent to be diminished even further.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Or so it was written in a memorandum submitted by the World Jewish Congress to Dr. Victor Hoo, the secretary of the United Nations Special Committee on Palestine. Schwarzbart’s employer believed that it had become “impossible for many Jews” to live in places such as Poland, Slovakia, Hungary, Austria, and Romania and that “Jewish survivors in the region” had to “seek a new life elsewhere.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" That elsewhere had already been determined. The “inexorable logic of facts” pushed “every objective observer” to the “conclusion that only Palestine can provide an answer for the Jewish masses who must emigrate from the lands in which normal life is no longer possible.” And since Palestine could absorb “all the Jews who desire to settle there,” there was no need for the WJC to suggest contingency plans. After centuries of persecution that culminated with Nazi policies of “uproot[ing],” murder, and the destruction of a “culture and way of life,” the pre–World War II world, the one that Schwarzbart clung to at that desk in England, “no longer existed.” In sum, the WJC urged the United Nations Special Committee on Palestine to agree that the movement of Jews away from Europe had become “inevitable.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The development of the argument casting the displaced Jews in postwar Europe as the ideal citizens of a Palestine-based Jewish polity was not inevitable."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" The negation of a significant slice of the postwar Jewish diaspora in the wake of the Second World War and the Holocaust was not necessarily self-evident. And although a majority of survivors and those who cared for them increasing saw the reestablishment of Jewish life throughout much of postwar Europe as untenable, the process by which this agreement emerged cannot be perceived as automatic. What, in 1947, the World Jewish Congress described as “inevitable” was in fact the opposite. The process by which east central Europeans of both Jewish and non-Jewish backgrounds as well as powerful Allied personalities sprinkled throughout Europe and North America came to the conclusion that the Jewish diaspora belonged “elsewhere” and should be transported there with the theoretical and financial support of a broader international community required a revolution in thinking about Jewish belonging, a sweeping change in international norms, and accelerated, deliberate work."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In detailing this drastic change, this book contributes a late chapter to an older story about Jewish belonging in Europe. Especially since the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("Enlightenment, intellectuals, diplomats, and statesmen of both Jewish and Christian heritage debated how Jews might synthesize their particular identities or supposed “otherness” with the rising modern notions of citizenship."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" In the nineteenth and twentieth centuries, a “Jewish question” emerged that was posed with increasing intensity as new states arose—Germany, Romania, and then Czechoslovakia and Poland."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Debates raged across generations, but at a certain point during the Second World War, a consensus formed among unlikely actors that promised to resolve the tensions of Jewish life in east central Europe swiftly and decisively.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To capture the coalescence of this consensus, "), _c('i', [_vm._v("Uprooting the Diaspora")]), _vm._v(" studies roughly a dozen people working in identifiable institutions such as east central European governments-in-exile, government bureaucracies in postwar Poland and Czechoslovakia, UNRRA, and the WJC. Together, they engineered new conceptions of Jewish territorial belonging, initiated a shift away from minority rights, and demanded that the overall unmixing of ethnicities within east central Europe include the endorsement of an “empirical Zionism” that equated those European Jews uprooted by war, occupation, genocide, and postwar events with Jewish displaced persons bound for old-new homes in the Middle East. All three of these significant interlaced transformations became part of an event that I call the “ethnic revolution,” which (at least according to Edvard Beneš) had roots in Nazi-era policies of demographic engineering, increasingly gained adherents within non-Jewish and Jewish Allied audiences across a very short period during and after the Second World War, and exploded with the willing support of important actors across the region in the wake of liberation."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("None of the actors in this book anticipated how their ideas about the nationalization of space, their opinions about an “empirical” form of Zionism, or their positions vis-à-vis the European Jewish question would change between 1936 and 1946. As their contemporary Stefan Zweig reminds us, “it remains an irrefragable law of history that contemporaries are denied a recognition of the early beginnings of the great movements which determine their times.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" While some of those covered on these pages seemed more prescient than others as the 1940s unfolded, Zweig’s observation (written during his own exile in early 1940s Brazil) stands almost without exception. This history of a particular decade-long conversation among non-Jewish and Jewish east central Europeans—such as Ignacy Schwarzbart, Edvard Beneš, Nahum Goldmann, Jan Masaryk, Arieh Tartakower, Joel Cang, Zorach Warhaftig, Aryeh Leon Kubowitzki, Yitzhak Zuckerman, and Jakob Apenszlak—reveals how definite ideas linking people to land eclipsed other ideas of ethnic and religious coexistence going back centuries."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" It all happened in a very short time, during and after the Second World War. Much of the story defies common expectations. For example, far from diminishing the intensity of nationalism, the Holocaust hardened senses of ethnicity. What seems evident to many observers in our day, that after World War II and the Shoah a Jewish political entity on Palestinian territory should exist and be populated by European Jews en masse, only became evident to the east central Europeans and observers of east central Europe studied here in an unpredictable and uneven way.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "",
      "src": "images/f005-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Mothers and their children enjoy Krasiński Garden in the Jewish quarter of interwar Warsaw. "), _c('span', {
    staticClass: "figc"
  }, [_vm._v("Courtesy YIVO Digital Archive on Jewish Life in Poland.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TIME, AUDIENCE, SPACE, AND LANGUAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I begin with a few words on time, audience, space, and language before I clarify three key concepts—the ethnic revolution, empirical Zionism, and the diaspora—that have already crisscrossed this introduction and will run like thin red lines through this narrative.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253064967_Chapter01"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" begins in August 1936 at the first meeting of the World Jewish Congress in Geneva. The narrative continues more or less chronologically and extends simultaneously to the end of 1946 across both "), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapters 4")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(". By the end of that year, language regarding the “Jewish origin” of some displaced persons entered drafts of what would soon become the constitution of the International Refugee Organization, and the flow of uprooted Polish Jews (most of whom had survived the 1940s in the Soviet Union) passing through Czechoslovakia toward other destinations slowed considerably. These events coincided with others to bring the ethnic revolution to a point of no return. While a noticeable piece of the Jewish diaspora that survived World War II and the Holocaust remained in Poland and Czechoslovakia at the end of 1946, a majority of Jewish survivors had sought new lives elsewhere (and not necessarily "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("in Palestine). Before and after the decade stretching from 1936 to 1946, this narrative includes some excavations of documents and personalities from the early 1930s (especially in "), _c('a', {
    attrs: {
      "href": "#/text/9780253064967_Chapter01"
    }
  }, [_vm._v("chapter 1")]), _vm._v("), and at other points its focus extends forward, such as when it covers Jan Masaryk’s address at the United Nations meeting in Lake Success during the fall of 1947 (as in "), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 5")]), _vm._v("), the WJC memorandum sent to the United Nations Special Committee on Palestine in the summer of that same year (as in this introduction), or the long-term consequences of the ethnic revolution in the conclusion.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Uprooting the Diaspora")]), _vm._v(" contributes to several historical literatures. First, this book (especially the first three chapters of it) offers a new institutional history of the World Jewish Congress and personalities therein from its establishment in 1936 throughout the Second World War and the immediate postwar era."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Second, by aligning a change of international norms regarding population transfers with plans for unprecedented levels of Jewish emigration away from this region and plans for the forced movement of other east central European minorities, including millions classified as “ethnic Germans,” I embed this Jewish story more firmly in an east central European one."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-13"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Third, this narrative illuminates how wartime thinking about Jewish belonging more generally collided with an awareness of the Shoah, other wartime horrors, and postwar circumstances and then translated (messily at times) into concrete policies impacting Jews who had citizenship in interwar Poland and Czechoslovakia and the possibilities for their movement away from the region."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-14"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Finally, "), _c('i', [_vm._v("Uprooting the Diaspora")]), _vm._v(" can be situated alongside other studies that explore Jewish nationalisms and the complex “Zionist movement” in east central Europe from the second half of the nineteenth century through the 1930s and the 1940s."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-15"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At its core, however, this is a book about a particular generation born in the late 1800s or early 1900s that came of age before empires dissolved during the Great War and intimately experienced life in one of two “new,” ethnically heterogenous post–World War I states: Poland and Czechoslovakia."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-16"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" For the most part, these particular men (and they were, mainly, men) took the rootedness of Jewish communities in east central Europe (a region that can extend beyond the borders of interwar Czechoslovakia and the Second Polish Republic but is centered in the footprint of those particular states) for granted—that is, until another, more exclusive way of linking ethnicity and territory became willingly and abruptly normalized during the first few years of the 1940s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now I would like to propose some general thoughts on language and its relation to the telling of the Jewish experience. Conversations about rootedness, uprootedness, and the consequences of both unfolded in settings replete with Jewish east central Europeans, non-Jewish east central Europeans, and "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("observers of the region from a variety of different religious, ethnic, and cultural backgrounds. The languages used in these conversations varied according to the participants, of course, but readers will notice that my archival searches across three continents privileged more documents written in Polish, Czech, and English than in Hebrew, Yiddish, or German. For instance, English dominates the documents drawn from the United Nations, other international organizations active in the 1940s, my survey of "), _c('i', [_vm._v("Foreign Affairs")]), _vm._v(" as well as the foreign correspondent’s desk of the "), _c('i', [_vm._v("Manchester Guardian")]), _vm._v(", and the archive of the World Jewish Congress. The largely unexplored émigré newspaper "), _c('i', [_vm._v("Nasza Trybuna")]), _vm._v(" (hereafter "), _c('i', [_vm._v("NT")]), _vm._v("), which showcases a more personal side of important figures in our narrative such as Ignacy Schwarzbart, WJC leader Arieh Tartakower, and editor-journalist Jakob Apenszlak, among others, was published mainly in Polish beginning in 1940 but used some English-language editions to reach a broader American audience. Descriptions of cultural events from Polish Jewish citizens that spread across the wartime Soviet Union, new ideas coalescing within east central European exiled governments, and policies crafted in postwar Poland and Czechoslovakia are preserved in Polish and Czech for the most part."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-17"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" And while authors exploring similar topics prioritize sources written in other Jewish languages (composed at the time and afterward), I am writing a different book."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-18"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" This is a story about the Jewish experience rooted in east central Europe until, at a certain point in the 1940s, important regional and international actors decided that this centuries-old status quo should irrevocably change. Coming from both Jewish and non-Jewish backgrounds, they communicated this change with each other and to their audiences largely in English, Czech, and Polish.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a larger sense—and here I consider the telling of Jewish history both in general and in this instance specifically—it is (almost) impossible to write about the Jewish experience without exploring how “Jews” interacted with “non-Jews.” It is essentially within these interactions that the Jewish experience assumes a larger and more transformative meaning. Take, for instance, the interaction between Czechoslovak president-in-exile Edvard Beneš and Vladimir Jabotinsky as detailed on the first pages of "), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 2")]), _vm._v(", which brings the collision of vocabularies justifying population transfers into sharper focus. Or consider the range of interactions between young and growing Polish Jewish families who survived the Second World War in Soviet Central Asia alongside “local” populations and other evacuees. This significant “surviving remnant,” their wartime experience, and their encounters with former “neighbors” who welcomed or cursed their eventual return “home” in 1946 are discussed in "), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 5")]), _vm._v(". And finally, as I consider in "), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapters 2")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(", important discussions "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("ensued between both Jewish and non-Jewish east central Europeans living in exile that reveal the difference between what they collectively “knew” about the complex web of regional and local events that tragically added up to the genocidal Holocaust and what they “accepted” as reality at specific moments. The merging of Jewish voices and the Jewish experience with broader east central European narratives about wartime intelligence, diplomatic consensus or disagreement, and societal coexistence or the tragic breakdown of communal relations results in a history that more closely resembles lived, contingent reality.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE ETHNIC REVOLUTION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I am not the first historian of east central Europe to write about the ethnic revolution of the 1940s. Over the past generation, historians of the Habsburg Empire and its successor states have found inspiration in the work of sociologist Rogers Brubaker and have introduced the category of “national indifference” into the telling of the past. Observers of the European past, Brubaker contends, should not assume that “nations” are timeless and existing entities, thereby reducing a “category of practice” to “category of analysis.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-19"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Brubaker casts “groupness” not as inevitable but as a special event deserving of its own chronology. Furthermore, the work of “nationalist activists” throughout east central Europe demonstrates the extent to which nationalism as a movement demanded hard work, especially among populations that did not necessarily have a “national consciousness” or that inhabited more than one linguistic universe. As acolytes of Brubaker tell the story, nationally “indifferent” peoples (those who celebrated their Czech-German bilingualism or those who felt local or regional identities instead of national ones, for example) became targets of national propaganda and pageantry in the second half of the nineteenth century and the first few decades of the twentieth century."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-20"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" The climax of these studies often aligns with the post–World War II expulsion of “ethnic” Germans (or the Volksdeutsche) from the territories of Czechoslovakia, Poland, and beyond. Close readings of these studies reveal how often our telling of the past bends toward a chronology that nationalists (be they Polish, Czech, or Jewish) create to justify both their political movement and their idealized ethnicized polity. When scholars understand “national indifference” as a viable category of analysis, historian Tara Zahra suggests, they can better problematize the rise of the ethnically defined nation-state."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-21"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What I hope to contribute is a combined emphasis on Jewish belonging, on the speed at which decisions about Jewish territoriality were made, and on the willingness of those involved to distance themselves from their former beliefs. "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("Notably, the Jewish and the German Jewish dimensions of the east central European ethnic revolution in the 1940s remain underexplored. Questions about “Jewish belonging” in the region hinge on two separate but interlaced elements: the parameters of the “Jewish people” (what could be called “national indifference”) and the boundaries of their “presumed” homeland (what could be called “territorial indifference”). As we will see in "), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 3")]), _vm._v(", members of the World Jewish Congress who joined the so-called American Emergency Committee for Zionist Affairs in 1942 could not agree which “ties” bound together “the Jewish people” even in the abstract, nor could they agree where “those” Jews belonged geographically, although many in attendance paid shekalim to indicate their membership in the World Zionist Organization."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-22"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" I return to this tension when I define “empirical Zionism” next, but in closing on this point, let me suggest that the uprootedness that Jewish populations in this region experienced during the Second World War and in the immediate postwar period necessitated drastic new answers for modern questions related to national and territorial indifference vis-à-vis the Jews."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-23"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" Accepting the movement of ethnically or nationally defined Jews away from Europe to a “new” homeland far away represented the pinnacle of the ethnic revolution just as the granting of citizenship to Jews represented the pinnacle of the French Revolution."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-24"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Besides illuminating the Jewish underpinnings of the ethnic revolution, "), _c('i', [_vm._v("Uprooting the Diaspora")]), _vm._v(" emphasizes two underappreciated aspects of this event: the speed of this revolutionary change and the willingness of those Jewish and non-Jewish actors who contributed to it. The following narrative extends from 1936 to 1946, but the ethnic revolution intensified twice within this decade: from the end of 1943 to the end of 1944 and again across just a few months during the second and third quarters of 1946. Both of these periods coincided with indecision within UNRRA related to a specific category of displaced persons or those “displaced persons unsuccessfully repatriated” to their prewar homes, be those homes in the former Czechoslovak region of Subcarpathian Rus’, the parts of eastern Poland ceded to the Ukrainian and Belarusian Soviet Socialist Republics, or cities, shtetlach, and villages made unlivable by war, occupation, uprising, or genocide. Essentially, over only a score of months, important voices in the Allied wartime and postwar universe (including some east central Europeans, some non-Jews previously committed to minority rights, and some Jews previously committed to preserving diaspora lives) made arguments, plans, and decisions to further uproot a significant portion of the remaining Jewish diaspora from communities where Jews had lived for many centuries. Since the transfer of populations realigned the demographics of east central Europe, wartime shifts in ideas about ethnic belonging greatly influenced the eventual "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("course of postwar socialist revolutions in the region as well."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-25"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" The change in thought and policy was swift, brutal, and yet, surprisingly, acceptable to other decision-makers (some very far from east central Europe) with a stake in the outcome."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-26"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" If the “ethnic revolution” required “hard work” from self-described nationalists, John Connelly reminds us that “plenty of people were willing to do it.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-27"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMPIRICAL ZIONISM")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Plenty of people, including those strongly committed to the Jewish diaspora in the region until the early 1940s and those in positions of Allied authority, became increasingly willing to definitively uproot that same diaspora when offered a new form of Zionism that made logistical sense. Out of the diverse and complex Zionist movement native to modern east central Europe, an empirical form of Zionism emerged by the mid-1940s."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-28"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" And while I technically named this concept, actors at the time definitively outlined the details of it."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-29"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Adherents of empirical Zionism equated the displaced Jews unable to return to their prewar homes with the ideal candidates for a “transfer” away from continental Europe and to an old-new homeland in Palestine. Their formula depended on three broader developments: the inability of UNRRA to offer viable solutions to specific Jewish aspects of the overwhelming displaced persons problem at that organization’s earliest meetings, the quick acceptance among east central European leaders such as Czechoslovak president-in-exile Edvard Beneš of population transfers to solve minority issues (and mainly the “German” minority issue) after the Second World War, and the tragic scale of the Shoah, which meant that the numbers of uprooted European Jews could be reasonably absorbed in the Palestinian Mandate. Given altered international norms, the breakdown of east central European societies along ethnic lines, and the sharp reduction in Jewish populations, empirical Zionism seemed like a logical response to the postwar Jewish question.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When faced with this confluence of events and the logic inherent in empirical Zionism, even statesmen and diplomats without Jewish roots, those with documented prewar Zionist sensitivities, or those inextricably tied to the diaspora began to consider a novel iteration of Zionism that seemed reasonable given the vastly changed circumstances. And notably, many who metamorphosized into empirical Zionists throughout this decade did so without consulting the surviving Jewish masses (most of whom survived the 1940s in the Soviet Union) that they claimed to represent. In many ways, this book charts how various actors imagined the future of Jews in east central Europe "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("rather than the actual experience of the men, women, and children uprooted by their visions and actions. And while these actors worked at a time marked by extreme urgency, chaos, and trauma, they imposed their own drastic visions on others nevertheless.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I tread carefully around the word "), _c('i', [_vm._v("Zionism")]), _vm._v(", even as I place the word "), _c('i', [_vm._v("empirical")]), _vm._v(" in front of it and historicize its emergence. Like other modern “isms,” this word is historically contingent and often too blunt when used in the abstract. Especially in the late nineteenth and early twentieth centuries, Zionism refers to a diverse and changing movement, not one static way of looking at the Jewish world. Throughout the Austrian Empire, for instance, “Zionists” and “Jewish nationalists” sometimes operated as distinct entities or political parties and sometimes did not, depending on circumstance and context."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-30"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" In Habsburg Galicia, where Schwarzbart was born and raised, the “Zionist” movement focused on two tracks: the “nationalization (of) Jewish identity and securing national rights in the Diaspora” very early."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-31"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Moving forward, throughout the Great War, the interwar period, and the early 1940s, the “Zionism” rooted in east central Europe “served a range of local functions—ones that, at first glance, might appear at odds with post-Holocaust conceptions of what Zionist activism entailed.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-32"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" In Czechoslovakia, for instance, Zionism became a “vehicle for integration and cultural survival.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-33"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" In Poland, “Zionist groups” took on distinctly Polish characteristics, as I explore more fully in "), _c('a', {
    attrs: {
      "href": "#/text/9780253064967_Chapter01"
    }
  }, [_vm._v("chapter 1")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-34"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" Far from “simple and carefree,” the Zionism explored in this book is “hard and complicated.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-35"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The histories of the World Zionist Organization and more extreme groups such as the New Zionist Organization (also known as the Revisionists) that splintered off from it contain decades-long and heated discussions about where a “perceived” Jewish nation could feel at home, who belonged to that nation, and how migration between the present and future should unfold. Of course, these discussions did not yield easy, dichotomous answers. The idea that Jews would continue to live in the European diaspora even after the consolidation of a Jewish polity somewhere else, as my first chapter shows, inspired even the most vocal Palestine-centric Zionists to continue “work in the diaspora” or "), _c('i', [_vm._v("Gegenwartsarbeit")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-36"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" In fact, this urge for more globally organized work in the places where Jews lived unleashed an organizing committee that eventually led to the creation of the World Jewish Congress, and some representatives within this organization attended World Zionist Organization meetings while they built up the WJC platform."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-37"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" And so, as Joshua Shanes has demonstrated, the “conventional distinction” between self-described “Zionists” and other Jewish nationalists falls apart on closer inspection."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-38"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("The elision of this distinction impacts the way I perceive the causal power of ideology more generally and an ideology dedicated to a transcendent nationstatism (be it Zionist, Czech, or Polish) more specifically. Ideology obviously matters when we talk about actors in this past (as well as any other past). "), _c('i', [_vm._v("Uprooting the Diaspora")]), _vm._v(" shows, however, that specifics of Zionist ideology, especially with regard to the position of a Jewish nation-state within that ideology, were in great flux during the short period covered in this book. It remains difficult, I think, to pinpoint something that is changing and attribute causality to that entity. Furthermore, an over-intensive focus on ideology, especially an ideology filtered through the narrow “prism of the nation-state,” conceals at least two things, according to Dmitry Shumsky: “the long and continuous series of political alternatives to the nation-state” that animated the political imagination of the Zionist movement and “specific changes” in the Zionist consciousness that prioritized an “ethnically Jewish” nation-state in Palestine."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-39"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" My goal is to chart how more general ideas about empirical Zionism, the rootedness of east central European Jews, and the viability of population transfers in this “hopelessly mixed” region changed swiftly and significantly during the particular decade in question. Some writings composed after events unfolded in 1948 and the labels of “Zionist,” “non-Zionist,” and “anti-Zionist” can obscure more than they clarify. We cannot excise these categorizations or ideologically driven histories composed after the establishment of Israel from our studies, but they need to be used with nuance. By challenging the inevitability of nation-state-focused ideology, my analysis “emphasizes the interconnectedness and fluidity” of Jewish thinking and seemingly distinctive political movements."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-40"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" And by following the acceptance of this highly contingent empirical Zionism beyond predominantly Jewish circles, my analysis also does something else.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My exploration of the east central European context and conversations encircling empirical Zionism in the 1940s reveals clear connections between the future of this European region and the future political belonging of Jews who were once rooted within it. Empirical Zionism is deeply imbricated within the broader ethnic revolution in east central Europe, and it is difficult to extract this form of Zionism from this particular time and, for the most part, this particular place. The success of this formula was contingent on east central Europeans realizing (and Edvard Beneš realized this sooner than almost everyone, as we see in "), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 2")]), _vm._v(") that the demographic unmixing of their region after the Second World War demanded the simultaneous embrace of Palestine as an ethno-territorial state that mirrored new ethnicized iterations of postwar Polish, Czechoslovak, and German body politics. Going even further, this book ventures beyond diplomatic memos and boardroom conversations to offer, in "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253064967_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 5")]), _vm._v(", an alternative reading of the postwar "), _c('i', [_vm._v("bricha")]), _vm._v(", or the semilegal movement of European Jews away from their European homes, often with stopovers in the postwar displaced persons camps.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE DIASPORA AND ITS")]), _vm._v(" “"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NEGATION")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Diaspora,” historian Erich Gruen observes, “lies deeply rooted in the Jewish consciousness.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-41"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Perhaps more than any other concept, it cuts across all the chronologies, geographies, and peoples that constitute Jewish civilization. Arguably, there is not one Jewish diaspora but many."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-42"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Those who tell the Jewish experience across millennia must devote time to Egypt, Babylon, the Iberian Peninsula, the Caribbean Islands, New York City, and the so-called Pale of Settlement as well as the hills, valleys, and deserts encircling Jerusalem. When cast against a Jewish backdrop, the word "), _c('i', [_vm._v("diaspora")]), _vm._v(" has a variety of connotations, from the biblical, eschatological, and liturgical to the rabbinic, spatial, and national. While "), _c('i', [_vm._v("Uprooting the Diaspora")]), _vm._v(" focuses mostly on the last two adjectives on that list, it is helpful to tease apart the idea of the “diaspora” before discovering how the east central European manifestation of it was definitively uprooted. And finally, during this excavation of both the word and the concept, let us not necessarily produce what we “describe or designate.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-43"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Like the concept of “nation,” the idea of the diaspora is “used to make claims, to articulate projects, to formulate expectations, to mobilize energies, to appeal to loyalties.” It is a category of analysis, to use Brubaker’s phrasing, that “does not so much describe the world as seek to remake it.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-44"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" To put it another way, Ignacy Schwarzbart assumed that the diaspora was a real entity existing in his world and on a defined historical timeline."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-45"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" Only with this awareness can we historically analyze what was obvious to him and so many of his colleagues.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Etymologically, "), _c('i', [_vm._v("diaspora")]), _vm._v(" is a Greek word that appears thirteen times in the Septuagint, a translation of the Hebrew bible for Hellenized readers dating from the third and second centuries BCE."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-46"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" Those translators used "), _c('i', [_vm._v("diaspora")]), _vm._v(" to represent a few Hebrew words but never to represent the Hebrew words "), _c('i', [_vm._v("galuth")]), _vm._v(" (displaced, against one’s will, from one’s home) and "), _c('i', [_vm._v("golah")]), _vm._v(" (residing in a foreign country)."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-47"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" These two words in Hebrew almost always refer in a negative sense to the so-called Babylonian exile during the sixth century BCE. The word "), _c('i', [_vm._v("diaspora")]), _vm._v(" in the Septuagint has a few connotations. For example, God uses this word to threaten Jews who are not respecting his commandments, and thus this word often connotes a “potential” dispersion related to divine power."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-48"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" As used in other Greek-language texts from the ancient world, the word "), _c('i', [_vm._v("diaspora")]), _vm._v(" does not necessarily carry a negative inflection. The Alexandrian Jewish philosopher "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("Philo understood "), _c('i', [_vm._v("diaspora")]), _vm._v(", for example, as referring to familial origins when he wrote in the first century CE. For Philo, all the Jews (or "), _c('i', [_vm._v("Ioudaioi")]), _vm._v(") living in Egypt possessed both a “metropolis” or a mother city and a “fatherland.” Thus, Philo and other Jews in Alexandria were descendants of their mother, Jerusalem, and of their father, “the country where [their] ancestors had chosen to live.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-49"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" Theirs was a voluntary emigration and not a forced exile.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Place and context changed the meanings of "), _c('i', [_vm._v("diaspora")]), _vm._v(" and "), _c('i', [_vm._v("galuth")]), _vm._v(" over time until eventually these words were used interchangeably in the modern era. The destruction of the Second Temple in 70 CE and the failure of the Bar Kochba Revolt in 135 CE initiated a new dispersion of people who followed evolving Jewish law away from Jerusalem and its environs. The Jewish sages writing in the first and second centuries CE increasingly used Hebrew (not Greek), and thus the word "), _c('i', [_vm._v("diaspora")]), _vm._v(" “gradually disappeared from Jewish thought and the meaning of "), _c('i', [_vm._v("galuth")]), _vm._v(" expanded” from only referencing historical exile to also absorbing the more neutral Septuagint meaning of dispersion. Both concepts were often cast in negative terms to connote loss, nakedness, and exile from the land “imposed by God.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-50"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" The idea of “the diaspora” also took on liturgical meaning in rabbinic texts and later the "), _c('i', [_vm._v("Talmudim")]), _vm._v(" whereby rituals performed “outside” of the historic biblical lands assumed different rules at times."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-51"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Finally, up through the modern period, diaspora and galuth assumed eschatological importance for some Jews who imagined that the messianic age would bring them and the bodies of their dead loved ones back to Jerusalem and its surroundings."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-52"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like other nationalists in east central Europe, Jewish nationalist activists would draw on this multilayered and historical concept of “diaspora” as a way to strengthen their nation’s claim to autonomy and eventually a specific land."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-53"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" It is important to note that the concept of diaspora expanded beyond the Jewish experience and entered into lexicons indicating other examples as well."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-54"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" Many Zionist-leaning Jewish nationalists spoke about diaspora and galuth/"), _c('i', [_vm._v("goles")]), _vm._v(" (in Hebrew and Yiddish, respectively) interchangeably as well as the so-called negation (or cancellation) of both as they designed their platforms and propaganda for the masses in the second half of the nineteenth century and afterward."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-55"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" In an oversimplified way, negating the diaspora implied abandoning diasporic homes and returning Jews to the land emanating outward from Jerusalem. Diaspora, as this section has shown, does not necessarily assume a negative aspect. By the advent of the age of nationalisms in the long nineteenth century, however, diaspora had become something that “had to be overcome.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-56"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("Political disagreements among Jews living in the region between Berlin and Moscow quite often hinged on one’s personal view of the diaspora, whether it should be negated, or how that negation should proceed. In 1909, for instance, the so-called “spiritual Zionist” Ahad Ha’am and “autonomist” Simon Dubnow exchanged articles directly challenging each other’s views on this range of topics, despite Dubnow’s contention that both men “stood together against those who completely negate[d] the diaspora.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-57"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" Dubnow admitted, however, that his own embrace of the diaspora was due to “historical necessity.” He suggested that both he and Ahad Ha’am would joyfully “transfer the entire Diaspora to a Jewish state” if they had the power to do so."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-58"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" Regardless, the revival of the spiritual center in Palestine depended on the “quantity” of “healthy national material” that the diaspora could offer."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-59"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" Other national leaders with Zionist leanings had much more pessimistic views of the diaspora despite the fact that Palestine could support only a fraction of the Jews rooted within it."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-60"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/9780253064967_Chapter01"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" confronts this reality explicitly. For now, we should note that Zionist activists such as Theodor Herzl, Aaron David Gordon, and others frequently cast the notion of “diaspora negation” as central to their political platforms demanding “human actions” such as migration and the creation of a Jewish polity in the Middle East."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-61"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" Once views about the diaspora were weaponized politically, the common ground that Dubnow sought in 1909 became even more elusive. A century after some these texts were written, it remains important for the historian to negotiate between the rhetoric and the reality."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-62"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" At times, the voices in this narrative use these words interchangeably, and the idea of diaspora is increasingly portrayed in gloomy shades as the chronology presented here moves forward. The description of diaspora provided here should help raise our consciousness when either occurs.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A SUCCINCT CHAPTER OUTLINE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Together, the five chapters of "), _c('i', [_vm._v("Uprooting the Diaspora")]), _vm._v(" detail the decade-long history of a transnational conversation about Jewish belonging that transpired between east central Europeans of both Jewish and non-Jewish backgrounds from a similar generation and other diplomats, politicians, and observers within the broader Allied universe. "), _c('a', {
    attrs: {
      "href": "#/text/9780253064967_Chapter01"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" draws on the work of sociologist Małgorzata Melchior and a collection of documents from the 1930s to explore the rootedness of Polish Jews during the interwar period, problematize calls for emigration away from Poland, and complicate terms such as "), _c('i', [_vm._v("Zionist")]), _vm._v(", "), _c('i', [_vm._v("anti-Zionist")]), _vm._v(", and "), _c('i', [_vm._v("non-Zionist")]), _vm._v(". "), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" begins in the 1940s and covers three years in "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("“exile” as east central Europeans in the Polish government-in-exile, the Czech government-in-exile, and the World Jewish Congress debated plans for the postwar world. Using words from Edvard Beneš, a survey of the journal "), _c('i', [_vm._v("Foreign Affairs")]), _vm._v(", the émigré Polish-language newspaper "), _c('i', [_vm._v("NT")]), _vm._v(", and documents from the World Jewish Congress, this chapter explores how plans for population transfers and the regranting of minority rights clashed publicly and privately. It also describes how conflicting news regarding the Jewish tragedy circulated throughout the Allied universe. "), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" covers the work and words emanating from the Office Committee of the World Jewish Congress across one calendar year. Between 1943 and 1944, the WJC reacted as the Allied powers failed to codify legal definitions for Jewish displaced persons at two UNRRA meetings, as the extent of the Jewish tragedy became more apparent, and as ideas casting displaced Jews within Europe as the ideal citizens for a Jewish polity in Palestine coalesced. Empirical Zionism emerged during the timeline of this chapter and helped shape the thinking of east central Europeans of both Jewish and non-Jewish backgrounds quickly and decisively.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the final two chapters, the diplomatic history showcased in "), _c('i', [_vm._v("Uprooting the Diaspora")]), _vm._v(" merges with a social story about two different postwar contexts (Czechoslovakia and Poland) in the same period, from 1945 to the fall of 1946. These chapters consider the links between the expulsion of “ethnic” Germans and postwar Jewish movements, how the category “displaced persons unsuccessfully repatriated” and ideas about Jewishness entered international and national legal codes, how postwar antisemitism proved more violent than its prewar iteration, and how more than a hundred thousand Polish Jews who survived World War II and the Holocaust in the Soviet Union returned to Poland and joined the "), _c('i', [_vm._v("bricha")]), _vm._v(". Finally, the short conclusion reflects on the so-called “ethnic revolution” and its consequences.")]), _vm._v(" "), _c('p', {
    staticClass: "commonimg"
  }, [_c('img', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "alt": "",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A peculiar travel document grows older in a gloomy archive deep within the maze of Prague’s cobblestoned streets. On its dimpled leather cover, gold letters shine in contrast to the deep-blue skin surrounding them: “Temporary Passport of the Czechoslovak Republic.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfna-63"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fna-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" Inside, a creased travel identity card reveals the target recipient: someone with “uncertain citizenship.” Beginning in 1947, after revisions to passport laws came into effect at the end of 1946, the Ministry of the Interior gave “authority to the departure” of travelers with “uncertain citizenship temporarily staying in Czechoslovakia.” The special page directs “controlling organs to facilitate the holder of this travel identity card in crossing the frontier on the described journey.” Empty lines encourage "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("the bearers to list their date of birth and their final destination. Unmarked boxes ask for descriptions of eye color, hair shade, and other distinguishing marks. Only clean versions of this passport remain in the dusty archival folders, marked with red and black pens alongside numbering systems that have outlived their necessity. Who were these European-born travelers without a European homeland, and how did their citizenship status become uncertain? Perhaps this study will help us understand who clutched these small documents and how their movement away from their prewar east central European homes became theoretically and logistically possible.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c74c09a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253064967_Introduction.vue
// module id = 84
// module chunks = 0